<template>
  <div class="modal fade" :class="{ show: isVisible }" tabindex="-1" aria-labelledby="exampleModalLabel"
    style="display: block" aria-modal="true" role="dialog" v-if="isVisible">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header border-0 m-0 justify-content-end">
          <div class="col-md-12 mb-3">
            <div class="contact-tab-wrap mb-0 px-2">
              <ul class="contact-nav nav justify-content-center">
                <li class="col-md-2 me-0">
                  <a href="javascript:;" class="active">Electricity</a>
                </li>
              </ul>
            </div>
          </div>
          <button class="btn-close" @click="closeModal">
            <i class="ti ti-x"></i>
          </button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row mt-1 border-top">
              <!-- <div class="col-md-12 mb-3">
                  <h5 class="text-center">{{ electricLinkData?.fullAddress }}</h5>
                </div> -->
              <div class="table-responsive p-0">
                <table class="table table-hover table-responsive table-bordered">
                  <thead>
                    <tr>
                      <!-- <th scope="col" class="bg-teal text-white">MPAN Top</th>
                        <th scope="col" class="bg-teal text-white text-center">
                          MPAN Bottom
                        </th> -->
                      <th scope="col" class="bg-teal text-white text-center">
                        Address Line 1
                      </th>
                      <th scope="col" class="bg-teal text-white">
                        Address Line 2
                      </th>
                      <th scope="col" class="bg-teal text-white text-center">
                        Address Line 3
                      </th>
                      <th scope="col" class="bg-teal text-white text-center">
                        Address Line 4
                      </th>
                      <!-- <th scope="col" class="bg-teal text-white">
                            Address Line 5
                        </th>
                        <th scope="col" class="bg-teal text-white text-center">
                            Address Line 6
                        </th>
                        <th scope="col" class="bg-teal text-white text-center">
                            Address Line 7
                        </th>
                        <th scope="col" class="bg-teal text-white text-center">
                            Address Line 8
                        </th>
                        <th scope="col" class="bg-teal text-white">
                            Address Line 9
                        </th>
                        <th scope="col" class="bg-teal text-white">
                            Post Code
                        </th>
                        <th scope="col" class="bg-teal text-white">
                            Supplier Name
                        </th>
                        <th scope="col" class="bg-teal text-white">
                            Supplier Effective Date
                        </th>
                        <th scope="col" class="bg-teal text-white">
                            Total Consumption
                        </th> -->
                    </tr>
                  </thead>
                  <tbody>
                    <tr @click="handleElecData()">
                      <!-- <td class="text-center">{{ electricLinkData.mpan }}</td>
                        <td>{{ electricLinkData.mpan }}</td> -->
                      <td class="text-center">{{ electricLinkData?.metering_point_address_line_1 }}</td>
                      <td class="text-center">{{ electricLinkData?.metering_point_address_line_2 }}</td>
                      <td class="text-center">{{ electricLinkData?.metering_point_address_line_3 }}</td>
                      <td class="text-center">{{ electricLinkData?.metering_point_address_line_4 }}</td>
                      <!-- <td class="text-center">{{ electricLinkData?.metering_point_address_line_5 }}</td>
                        <td class="text-center">{{ electricLinkData?.metering_point_address_line_6 }}</td>
                        <td class="text-center">{{ electricLinkData?.metering_point_address_line_7 }}</td>
                        <td class="text-center">{{  electricLinkData?.metering_point_address_line_8 }}</td>
                        <td class="text-center">{{  electricLinkData?.metering_point_address_line_9 }}</td>
                        <td class="text-center">{{ electricLinkData.post_code }}</td>
                        <td class="text-center">{{ electricLinkData.supplier_name }}</td>
                        <td class="text-center">{{ electricLinkData.supplier_efd }}</td>
                        <td class="text-center">{{ electricLinkData.total_eac }}</td> -->
                    </tr>
                  </tbody>
                </table>

                <div class="d-flex justify-content-end mt-3">
                  <button type="button" class="btn btn-outline-dark"
                    @click="isPowwrData ? handleElecClickPowwr(electricDataRawPowwr) : handleElecClick(electricLinkData)">Copy</button>
                </div>

                <div v-if="elecClick">
                  <table class="table table-bordered mt-2">
                    <tbody>

                      <!-- Render normal fields -->
                      <tr v-for="(value, key) in electricLinkData" :key="key">
                        <td v-if="key !== 'additional_detail'"><strong>{{ formatLabel(key) }}</strong></td>
                        <td v-if="key !== 'additional_detail'">{{ value }}</td>
                      </tr>


                      <!-- Address fields -->
                      <tr v-if="electricLinkData?.additional_detail?.length > 0">
                        <td colspan="2"><strong>Additional Details</strong></td>
                      </tr>
                      <tr v-for="(value, key) in electricLinkData?.additional_detail?.[0]" :key="'address-' + key">
                        <td><strong>{{ formatLabel(key) }}</strong></td>
                        <td>{{ value }}</td>
                      </tr>

                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ref,
  onMounted,
  watch,
  onUnmounted,
  computed,
  defineEmits
} from "vue";
import {
  useStore
} from "vuex";
import {
  useRouter,
  useRoute
} from "vue-router";
import {
  Form,
  Field,
  ErrorMessage
} from "vee-validate";
import { useToast } from "vue-toast-notification";

export default {
  props: {
    formData: {
      type: Array
    },
    supplierOptions: {
      type: Array
    },
    electricLinkData: {
      type: Object
    },
    isVisible: {
      type: Boolean,
    },
    fromOpp: {
      type: Boolean,
      default: false,
    },
    isPowwrData: {
      type: Boolean,
      default: false,
    },
    electricDataRawPowwr: {
      type: Object,
      default: null,
    },
  },
  components: {
    Form,
    Field,
    ErrorMessage,
  },
  setup(props, {
    emit
  }) {
    const store = useStore();
    //   const hasData = ref(false)
    const toast = useToast();
    const elecClick = ref(false)
    const closeModal = () => {
      // hasData.value = false
      // electricLinkData.value = [];
      elecClick.value = false;
      emit("close"); // Now correctly using emit
    };

    const handleElecClick = (electricLinkData) => {
      // props.formData.mainProductService === 'elec';
      props.formData.main_production_service?.toLowerCase() === 'elec'
      // if (props.formData.mainProductService === 'elec' || props.formData.main_production_service?.toLowerCase() === 'elec') {
      if (props.fromOpp) {
        props.formData.supply_address.building_name = electricLinkData?.metering_point_address_line_3 + ' ' + electricLinkData?.metering_point_address_line_4;
        props.formData.supply_address.city = electricLinkData?.metering_point_address_line_5;
        props.formData.supply_address.county = electricLinkData?.metering_point_address_line_9;
        props.formData.supply_address.street = electricLinkData?.metering_point_address_line_8;
        props.formData.supply_address.postcode = electricLinkData?.post_code;
        props.formData.mpan_bottom = electricLinkData.mpan;
        const supplier_id = findSupplierId(electricLinkData?.supplier_name)
        props.formData.supplier_id = supplier_id;
        props.formData.forecast_commission.sc_forecast_or_amended_annual_consumption = electricLinkData?.total_eac;

        const profileClass = String(electricLinkData?.additional_detail?.[0].profile_class || '')
          .padStart(2, '0');

        const mtcId = String(electricLinkData?.additional_detail?.[0].mtc_id || '')
          .padStart(3, '0');

        const llf = String(electricLinkData?.line_loss_factor_class_id || '')
          .slice(-3) // get last 3 chars
          .padStart(3, '0') // ensure length 3
          .toLowerCase();

        props.formData.mpan_top = (profileClass + mtcId + llf).toUpperCase();

      } else if (props.formData.mainProductService === 'elec') {
        props.formData.quoteDetails.ElectricSupply.StandardSettlementConfig = electricLinkData?.standard_settlement_configuration_id;
        props.formData.quoteDetails.ElectricSupply.DayConsumption.Amount = electricLinkData?.total_eac;
        props.formData.quoteDetails.PostCode = electricLinkData?.post_code;
        props.formData.quoteDetails.ElectricSupply.MPANBottom = electricLinkData?.mpan;
        props.formData.quoteDetails.CurrentSupplier = electricLinkData?.supplier_name;
        props.formData.quoteDetails.ElectricSupply.MeterType = electricLinkData?.additional_detail?.[0].meter_type;
        props.formData.quoteDetails.ElectricSupply.MeasurementClass = electricLinkData?.additional_detail?.[0].measurement_class;
        const profileClass = String(electricLinkData?.additional_detail?.[0].profile_class || '')
          .padStart(2, '0');

        const mtcId = String(electricLinkData?.additional_detail?.[0].mtc_id || '')
          .padStart(3, '0');

        const llf = String(electricLinkData?.line_loss_factor_class_id || '')
          .slice(-3) // get last 3 chars
          .padStart(3, '0') // ensure length 3
          .toLowerCase();

          props.formData.quoteDetails.ElectricSupply.MPANTop = (profileClass + mtcId + llf).toUpperCase();
          props.formData.quoteDetails.ProfileClass = electricLinkData?.additional_detail?.[0].profile_class;
          props.formData.quoteDetails.LineLossFactorClass = electricLinkData?.line_loss_factor_class_id;
      }
      // }
      closeModal()
    }

    /** Copy handler for Powwr MPAN response; does not modify existing handleElecClick. */
    const handleElecClickPowwr = (rawPowwrMeter) => {
      if (!rawPowwrMeter || typeof rawPowwrMeter !== 'object') return;
      const loc = rawPowwrMeter.meterPointLocation || {};
      const supplier = rawPowwrMeter.currentSupplier || {};
      const profileClass = String(rawPowwrMeter.profileClass ?? '').padStart(2, '0');
      const mtcId = String(rawPowwrMeter.meterTimeswitchClass ?? '').padStart(3, '0');
      const llf = String(rawPowwrMeter.lineLossFactor ?? '').slice(-3).padStart(3, '0').toLowerCase();
      const mpanTop = (rawPowwrMeter.standardSettlementConfiguration && rawPowwrMeter.standardSettlementConfiguration != '') ? (profileClass + rawPowwrMeter.standardSettlementConfiguration + llf).toUpperCase() : (profileClass + mtcId + llf).toUpperCase();
      const supplierName = supplier.name ?? '';

      if (props.fromOpp) {
        props.formData.supply_address.building_name = [loc.addressLine3, loc.addressLine4].filter(Boolean).join(' ');
        props.formData.supply_address.city = loc.addressLine5 ?? '';
        props.formData.supply_address.county = loc.addressLine9 ?? '';
        props.formData.supply_address.street = loc.addressLine8 ?? '';
        props.formData.supply_address.postcode = loc.postCode ?? '';
        props.formData.mpan_bottom = rawPowwrMeter.mpan ?? '';
        const supplier_id = findSupplierId(supplierName);
        props.formData.supplier_id = supplier_id;
        props.formData.forecast_commission.sc_forecast_or_amended_annual_consumption = rawPowwrMeter.annualConsumption ?? '';
        props.formData.mpan_top = mpanTop;
      } else if (props.formData.mainProductService === 'elec') {
        props.formData.quoteDetails.ElectricSupply.StandardSettlementConfig = rawPowwrMeter.standardSettlementConfiguration ?? '';
        props.formData.quoteDetails.ElectricSupply.DayConsumption.Amount = rawPowwrMeter.annualConsumption ?? '';
        props.formData.quoteDetails.PostCode = loc.postCode ?? '';
        props.formData.quoteDetails.ElectricSupply.MPANBottom = rawPowwrMeter.mpan ?? '';
        props.formData.quoteDetails.CurrentSupplier = supplierName;
        props.formData.quoteDetails.ElectricSupply.MeterType = rawPowwrMeter.meterType ?? '';
        props.formData.quoteDetails.ElectricSupply.MeasurementClass = rawPowwrMeter.measurementClass ?? '';
        props.formData.quoteDetails.ElectricSupply.MPANTop = mpanTop;
        props.formData.quoteDetails.ProfileClass = rawPowwrMeter.profileClass ?? '';
        props.formData.quoteDetails.LineLossFactorClass = rawPowwrMeter.lineLossFactor ?? '';
        props.formData.quoteDetails.MhhsMigrated = rawPowwrMeter.mhhsIndicator ?? '';
        props.formData.quoteDetails.DuosTariffId = rawPowwrMeter.duosTariffId ?? '';
        props.formData.quoteDetails.MeterTimeswitchClass = rawPowwrMeter.meterTimeswitchClass ?? '';
        props.formData.quoteDetails.Settings[1].value = 50;
      }
      closeModal();
    };

    const handleElecData = () => {
      elecClick.value = !elecClick.value;
    }

    // Function to format labels (replaces underscores with spaces and capitalizes)
    const formatLabel = (key) => {
      return key
        .replace(/([a-z])([A-Z])/g, "$1 $2") // Add space before uppercase letters
        .replace(/_/g, " ") // Replace underscores with spaces
        .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
    };

    const findSupplierId = (supplierName) => {
      if (!supplierName || !props.supplierOptions) return null;

      const inputName = supplierName.toLowerCase();

      // 1. Try exact match using `includes()`
      let bestMatch = props.supplierOptions.find(option =>
        option.text.toLowerCase().includes(inputName)
      );

      // 2. If no match, try checking the first two words of `inputName`
      if (!bestMatch) {
        const firstTwoWords = inputName.split(" ").slice(0, 2).join(" ");

        bestMatch = props.supplierOptions.find(option =>
          option.text.toLowerCase().includes(firstTwoWords)
        );
      }

      return bestMatch ? bestMatch.id : null;
    };

    // Watch for changes in visibility to apply or remove the backdrop
    watch(
      () => props.isVisible,
      (newValue) => {
        const backdropClass = "modal-backdrop";
        if (newValue) {
          // Modal is opened
          document.body.classList.add("modal-open");
          const backdrop = document.createElement("div");
          backdrop.className = `${backdropClass} fade show`;
          document.body.appendChild(backdrop);
        } else {
          // Modal is closed
          document.body.classList.remove("modal-open");
          const backdrop = document.querySelector(`.${backdropClass}`);
          if (backdrop) {
            backdrop.remove();
          }
        }
      }
    );

    // Cleanup on component unmount
    onUnmounted(() => {
      document.body.classList.remove("modal-open");
      const backdrop = document.querySelector(".modal-backdrop");
      if (backdrop) {
        backdrop.remove();
      }
    });

    return {
      store,
      closeModal,
      handleElecClick,
      handleElecClickPowwr,
      handleElecData,
      elecClick,
      formatLabel,
      findSupplierId,
    };
  },
};
</script>

<style scoped>
.modal {
  display: block;
  /* Ensure modal is displayed correctly */
}

.row_click {
  cursor: pointer;
}

.table_height {
  max-height: 428px;
}
</style>
